import { render, staticRenderFns } from "./staffShift.vue?vue&type=template&id=6f52136c"
import script from "@/scripts/dashboard/components/staffShift.js?vue&type=script&lang=js&external"
export * from "@/scripts/dashboard/components/staffShift.js?vue&type=script&lang=js&external"
import style0 from "./staffShift.vue?vue&type=style&index=0&id=6f52136c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports